import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Grid2 as Grid, TextField } from '@mui/material';

import { SharedConstants } from '../../common/constants/shared';
import { PPWBHeader } from './Header';
import { getPolicy, getPolicyIdByCarrierPolicyNumber } from './helpers';
import styles from './styles.module.scss';

export const PPWBLanding = () => {
  useEffect(() => {
    // Update the document title using the browser API
    document.title = `Product Performance Work Bench`;
  }, []);

  /**
   * PolicyID could be either internal policy id or carrier policy id
   */
  const [policyID, setPolicyID] = useState('');
  const navigate = useNavigate();

  const handleEnter = (e: any) => {
    if (e.key === 'Enter') {
      openPolicy();
      e.preventDefault();
    }
  };
  const openPolicy = async () => {
    let searchId = policyID;
    if (searchId.length > SharedConstants.MAX_INTERNAL_POLICY_LENGTH) {
      searchId = String(await getPolicyIdByCarrierPolicyNumber(searchId));
    }
    const parsedPolicyId = parseInt(searchId, 10);
    if (Number.isNaN(parsedPolicyId)) {
      alert('invalid policy id or carrier policy number');
      return;
    }

    const policy = await getPolicy(searchId);
    if (policy) {
      navigate('/workbench/ppwb/policy/' + searchId, { state: { policy } });
    } else {
      alert('invalid policy id or carrier policy number');
    }
  };
  return (
    <div className={styles.Layout}>
      <div className={styles.Column}>
        <PPWBHeader />
        <Grid container={true}>
          {' '}
          <TextField
            required
            value={policyID}
            onKeyDown={handleEnter}
            onChange={e => setPolicyID(e.target.value)}
            className={styles.InputBox}
            label="Policy ID or Carrier Policy Number"
            variant="outlined"
            slotProps={{
              htmlInput: {
                maxLength: 16,
              },
            }}
          />{' '}
          <Button
            className={styles.InputButton}
            variant="contained"
            onClick={openPolicy}
          >
            Go
          </Button>{' '}
        </Grid>
      </div>
    </div>
  );
};
